var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2784 16.575L14.7431 10.1718C15.275 8.78903 16.2133 7.5999 17.4345 6.76105C18.6556 5.92221 20.1023 5.47301 21.5838 5.47266H42.1536C42.7316 5.47527 43.3003 5.61858 43.8105 5.89019C44.3207 6.16181 44.7571 6.55356 45.082 7.03161C45.4069 7.50966 45.6105 8.05963 45.6752 8.634C45.74 9.20836 45.6639 9.78986 45.4536 10.3282L42.9888 16.575H12.2784ZM11.52 18.5495L7.26363 29.6167H32.048C33.843 29.4624 35.5594 28.8111 37.0048 27.7357C38.4502 26.6604 39.5674 25.2036 40.231 23.5287L42.2 18.55L11.52 18.5495ZM6.50504 31.588L2.30399 42.5095H11.325C12.3681 42.5094 13.3867 42.1936 14.247 41.6037C15.1072 41.0138 15.7688 40.1774 16.1448 39.2045L19.089 31.5878L6.50504 31.588Z",
    fill: "url(#paint0_linear_2_2032)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2032",
    x1: 24.0008,
    y1: 4.06526,
    x2: 24.0008,
    y2: 43.9169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F64FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4098fee79f68ceb9e32095f3e9025f24.svg";
export { ForwardRef as ReactComponent };